import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlugWithErrorIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 55,
	viewBox: "0 0 34 55",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.25008 14.3337H5.33341C3.7226 14.3337 2.41675 15.6395 2.41675 17.2503V26.9724C2.41675 28.2348 2.82613 29.4627 3.58341 30.4724L10.0001 39.0282C10.7574 40.0379 11.1667 41.2659 11.1667 42.5282V46.417C11.1667 49.6387 13.7783 52.2503 17.0001 52.2503C20.2218 52.2503 22.8334 49.6387 22.8334 46.417V42.5282C22.8334 41.2659 23.2429 40.0379 24.0001 39.0282L30.4167 30.4724C31.1739 29.4627 31.5834 28.2348 31.5834 26.9724V17.2503C31.5834 15.6395 30.2776 14.3337 28.6667 14.3337H25.7501M8.25008 14.3337V2.66699M8.25008 14.3337H25.7501M25.7501 14.3337V2.66699",
			stroke: "currentColor",
			strokeWidth: 4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 29.5L20.5 22.5",
			stroke: "currentColor",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 22.5L20.5 29.5",
			stroke: "currentColor",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPlugWithErrorIcon;
